import { CustomAppLayout } from '../../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useMemo, useState } from 'react';
import { useRouter } from '../../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Box, Button, Container, FormField, ItemCard, Link, Modal, Select, SelectProps, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAirplaneLanding, mdiAirplaneTakeoff, mdiBackupRestore, mdiClockEditOutline, mdiContentCopy, mdiDelete, mdiHumanMaleBoard, mdiPlus, mdiProgressWrench, mdiReload, mdiTowTruck } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import BadgeCustom from '../../../../../../components/extras/BadgeCustom';
import ConfirmDelete from '../../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../../components/extras/Favorites';
import UserAvatar from '../../../../../../components/extras/UserAvatar';
import SelectBookingType from '../../../../../../components/selects/selectBookingTypes';
import SelectEquipment from '../../../../../../components/selects/selectEquipment';
import SelectUser from '../../../../../../components/selects/selectUser';
import TPModal from '../../../../../../components/TPModal';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { btnIcon, ItemAltitudes, ItemShift, ItemShiftFlight } from '../../../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getBookingType, getCookie, getEquipment, getUrlVersion, getUser, setData, setLoading } from '../../../../../commons/functions';
type OptionDefinition = SelectProps.Option;
export const MembersEtcShiftsFlightsPage = () => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName, RUT } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();
    const [altitudes, setAltitudes] = useState<ItemAltitudes[]>([]);
    const [flight, setFlight] = useState<ItemShiftFlight>();
    const [flightEdit, setFlightEdit] = useState<ItemShiftFlight>();
    const [flightDelete, setFlightDelete] = useState<ItemShiftFlight>();
    const [flightRestore, setFlightRestore] = useState<ItemShiftFlight>();
    const [flightCopy, setFlightCopy] = useState<ItemShiftFlight>();
    const [shift, setShift] = useState<ItemShift>();
    const [showFilter, setShowFilter] = useState(false);
    const [flights, setFlights] = useState<ItemShiftFlight[]>([]);
    const [selectedAction, setSelectedAction] = useState<OptionDefinition>({ value: "ALL", label: "Todos" });
    const [altitude, setAltitude] = useState<ItemAltitudes>();

    const initFlight = () => {
        setAltitudes([])
        setAltitude(undefined)
        setFlight({
            idShift: shift.idShift, idFlight: 0, sequence: 0, idEquipment: 0, idUserPilot: 0, idUserInstructor: 0, altitude: -1, idEquipmentTow: 0, idUserTow: 0, departureDate: "", arrivalDate: "", arrivalDateTow: "", obs: "", isClosed: 0, idFlightType: 0, isDelete: 0
        })
    }

    useEffect(() => {
        if (flight && flight.idEquipment) {
            const foundItem = data.equipments.find((item: { idEquipment: number; registration: string, jsonAltitudes: any }) => item.idEquipment === Number(flight.idEquipment));
            if (foundItem) {

                const mappedAltitudes: ItemAltitudes[] = foundItem.jsonAltitudes.map((altitude: ItemAltitudes) => ({
                    altitude: altitude.altitude,
                    label: String(altitude.altitude) + " metros",
                    value: String(altitude.altitude),
                }));
                setAltitudes(mappedAltitudes);
            }
        }
    }, [flight?.idEquipment]);
    useEffect(() => {
        handleGetShift();
    }, []);
    const handleGetShift = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/get',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ isToday: 1, flights: true })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.shift) {
                setShift(data.shift)

                if (data.shift.flights) {
                    //console.log(data.shift.flights)
                    setFlights(data.shift.flights)
                }
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleFlightDelete = async (isDelete: number) => {
        let body = {
            idFlight: isDelete === 1 ? flightDelete.idFlight : flightRestore.idFlight,
            idShift: isDelete === 1 ? flightDelete.idShift : flightRestore.idShift,
            isDelete: isDelete
        }
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/flights/update',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.shift) {
                setFlightRestore(undefined)
                setFlightDelete(undefined)
                addNotification(data.status, "success", setData)
                if (data.shift.flights) {
                    setFlights(data.shift.flights)
                }
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleUpdateFlight = async (type: string) => {
        let body = type === "ADD" ? flight : type === "COPY" ? flightCopy : flightEdit;
        //console.log(type, body)
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/flights/update',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.shift) {
                setShift(shift)
                setFlight(undefined);
                setFlightEdit(undefined);
                setFlightCopy(undefined);
                addNotification(data.status, "success", setData)
                if (data.shift.flights) {
                    setFlights(data.shift.flights)
                }
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const extendedFlights = useMemo(() => {
        if (!flights) return [];

        return flights.map((f: ItemShiftFlight) => {
            // Helper to strip "CC-" prefix
            const cleanReg = (id: number) =>
                getEquipment(id, data)?.registration?.replace("CC-", "") ?? "";

            return {
                ...f,
                // Add the new keys
                registration: cleanReg(f.idEquipment),
                registrationTow: f.idEquipmentTow > 0 ? cleanReg(f.idEquipmentTow) : "",
                userPilot: getUser(f.idUserPilot, data)?.displayName ?? "",
                userInstructor: getUser(f.idUserInstructor, data)?.displayName ?? "",
                userTow: getUser(f.idUserTow, data)?.displayName ?? "",
                flightType: getBookingType(f.idFlightType, data)?.bookingType ?? "",
                flightTypeBadge: getBookingType(f.idFlightType, data)?.bookingTypeBadge ?? ""
            };
        });
    }, [flights, data]);

    const opsNotStarted = flights?.filter(f => f.isDelete === 0 && f.departureDate === "" && f.arrivalDateTow === "" && f.arrivalDate === "").length || 0;
    const opsActiveTow = flights?.filter(f => f.isDelete === 0 && f.departureDate !== "" && f.arrivalDateTow === "").length || 0;
    const opsActiveGlider = flights?.filter(f => f.isDelete === 0 && f.departureDate !== "" && f.arrivalDate === "").length || 0;
    const opsFinish = flights?.filter(f => f.isDelete === 0 && f.departureDate !== "" && f.arrivalDate !== "" && f.arrivalDateTow !== "").length || 0;


    const filterTypes: OptionDefinition[] = [
        { label: `Todos [${flights?.filter(f => f.isDelete === 0).length || 0}]`, value: "ALL" },
        {
            label: `S/Despegue [${opsNotStarted}]`, value: "1",
            description: "Planeador en tierra",
            disabled: opsNotStarted === 0
        },
        {
            label: `S/Remolque [${opsActiveTow}]`, value: "2",
            description: "Remolcador en vuelo",
            disabled: opsActiveTow === 0
        },
        {
            label: `S/aterrizaje [${opsActiveGlider}]`, value: "3",
            description: "Planeador en vuelo",
            disabled: opsActiveGlider === 0
        },

        {
            label: `Finalizados [${opsFinish}]`, value: "4",
            description: "Planeador y remolcador aterrizado",
            disabled: opsFinish === 0
        },
        { label: `Eliminados [${flights?.filter(f => f.isDelete === 1).length || 0}]`, value: "DELETE", disabled: flights.length === 0 },
    ]
    const isValidNewFlight = () => {
        let valid = true;
        if (!flight) return false
        if (flight.idFlightType === 0 || flight.idEquipment === 0 || flight.idUserPilot === 0) return true;
        if ((flight.idFlightType === 1135 || flight.idFlightType === 1133) && flight.idUserInstructor === 0) return true;
        if (flight.altitude > 0 && (flight.idEquipmentTow === 0 || flight.idUserTow === 0)) return true;
        if (flight.altitude === -1) return true;
        return !valid
    }

    const filteredFlights = useMemo(() => {
        if (!extendedFlights) return [];

        return extendedFlights.filter((f: ItemShiftFlight) => {
            const filterVal = selectedAction.value;

            // 1. If we are explicitly looking at the Trash
            if (filterVal === "DELETE") {
                return f.isDelete === 1;
            }

            // 2. FOR ALL OTHER VIEWS (1, 2, 3, 4, and "ALL"):
            // If it's deleted, we filter it out immediately.
            if (f.isDelete === 1) {
                return false;
            }

            // 3. If we're here, it's NOT deleted.
            // If the user selected "ALL", we can return true now.
            if (filterVal === "ALL") {
                return true;
            }

            // 4. Specific status logic for non-deleted items
            const hasDep = !!f.departureDate;
            const hasTowArr = !!f.arrivalDateTow;
            const hasFinalArr = !!f.arrivalDate;

            switch (filterVal) {
                case "1": return !hasDep && !hasTowArr && !hasFinalArr;
                case "2": return hasDep && !hasTowArr; // && !hasFinalArr;
                case "3": return hasDep && !hasFinalArr; //hasTowArr && 
                case "4": return hasDep && hasTowArr && hasFinalArr;
                default: return true;
            }
        });
    }, [extendedFlights, selectedAction]);
    const flightStatus = ((item: ItemShiftFlight) => {
        ////console.log(item)
        const f1 = (<BadgeCustom color={item.departureDate !== "" ? "green" : "lightgrey"}><Icon path={mdiAirplaneTakeoff} size={1} />
            {item.departureDate === "" ? "--:--" : item.departureDate}
        </BadgeCustom>)
        const f2 = (<BadgeCustom color={item.arrivalDateTow !== "" ? "green" : "lightgrey"}><Icon path={mdiTowTruck} size={1} />
            {item.arrivalDateTow === "" ? "--:--" : item.arrivalDateTow}
        </BadgeCustom>)
        const f3 = (<BadgeCustom color={item.arrivalDate !== "" ? "green" : "lightgrey"}><Icon path={mdiAirplaneLanding} size={1} />
            {item.arrivalDate === "" ? "   --:--   " : item.arrivalDate}
        </BadgeCustom>)
        return (<SpaceBetween direction='horizontal' size="xs">{f1}{item.altitude > 0 ? f2 : ""}{f3}</SpaceBetween>)
    })

    const distinctEquipments = useMemo(() => {
        if (!flights) return [];
        return Array.from(new Set(flights.map(f => f.idEquipment)));
    }, [flights]);

    const distinctEquipmentsTow = useMemo(() => {
        if (!flights) return [];
        return Array.from(new Set(flights.map(f => f.idEquipmentTow)));
    }, [flights]);

    const distinctPilots = useMemo(() => {
        if (!flights) return [];
        return Array.from(new Set(flights.map(f => f.idUserPilot)));
    }, [flights]);

    const distinctInstructors = useMemo(() => {
        if (!flights) return [];
        return Array.from(new Set(flights.map(f => f.idUserInstructor)));
    }, [flights]);

    const distinctTowings = useMemo(() => {
        if (!flights) return [];
        return Array.from(new Set(flights.map(f => f.idUserTow)));
    }, [flights]);

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={

                <SpaceBetween size="s">
                    <Header variant="h1"
                        description={shift?.userDirector ? `Director: ` + shift.userDirector : ""}
                        actions={

                            <Favorites />
                        }>Planilla {shift?.dateShift ?? ""}<Link onClick={() => {
                            setShowFilter(!showFilter)
                        }}><Icon path={mdiProgressWrench} size={1.2} color={showFilter ? "black" : "grey"} /></Link></Header>
                    {showFilter && (
                        <SpaceBetween direction='horizontal' size='xs'>
                            <FormField label={"Filtro"}>


                                <Select options={filterTypes}
                                    onChange={(e) => {
                                        if (e.detail.selectedOption.value === "ADD") {

                                            setSelectedAction({ value: "", label: "Seleccione" })
                                        } else {
                                            setSelectedAction(e.detail.selectedOption)
                                        }
                                    }}
                                    selectedOption={filterTypes.find((e: OptionDefinition) => (selectedAction.value === e.value))}
                                />
                            </FormField>

                            <FormField label="&nbsp;">
                                <Button style={{ root: btnIcon }} onClick={() => handleGetShift()}><Icon path={mdiReload} size={1} /></Button>
                            </FormField>

                            <FormField label="&nbsp;">
                                <Button style={{ root: btnIcon }} onClick={() => initFlight()}><Icon path={mdiPlus} size={1} /></Button>
                            </FormField>
                        </SpaceBetween>
                    )}
                    {flight !== undefined && (
                        <Modal size="medium" header={"Ingresar"} onDismiss={() => setFlight(undefined)} visible={flight !== undefined}
                            footer={
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", }}>
                                    <Button variant="link" onClick={() => setFlight(undefined)}>Cancelar</Button>
                                    <Button variant="primary" disabled={isValidNewFlight()} onClick={() => handleUpdateFlight("ADD")}>Ingresar</Button>
                                </div>
                            }
                        >
                            <SpaceBetween direction='vertical' size='xs'>
                                <FormField label={"Tipo de vuelo"}>
                                    <SelectBookingType value={flight.idFlightType} onSelect={(ft) => {
                                        //console.log("Selected:", ft)
                                        setFlight({ ...flight, idFlightType: ft?.idBookingType ?? 0 })
                                    }} />
                                </FormField>
                                {flight.idFlightType !== undefined && flight.idFlightType > 0 && (
                                    <>
                                        <FormField label={"Material"}
                                            constraintText={
                                                distinctEquipments.map((id: number) => {
                                                    const registration = getEquipment(id, data)?.registration.replace("CC-", "");
                                                    if (!registration) return null;
                                                    return (<Link
                                                        key={id}
                                                        variant="primary"
                                                        onClick={() => {
                                                            setFlight({ ...flight, idEquipment: id })
                                                        }}
                                                    >{registration} </Link>);
                                                })
                                            }
                                        >
                                            <SelectEquipment
                                                key={flight.idFlightType}
                                                idCategory={flight.idFlightType === 145294 ? 911557 : 0}
                                                isBookCapable={flight.idFlightType === 145294 ? -1 : 1}
                                                groupTypeMasterCode={flight.idFlightType !== 145294 ? "GLIDER" : ""}
                                                value={flight.idEquipment} onConfirm={(eq) => {
                                                    setFlight({ ...flight, idEquipment: eq?.idEquipment ?? 0 })

                                                }} />
                                        </FormField>
                                        <FormField label={"Piloto"}>
                                            <SpaceBetween direction='horizontal' size='xs'>
                                                <SelectUser value={flight.idUserPilot} onConfirm={(usr) => {
                                                    setFlight({ ...flight, idUserPilot: usr?.idUser ?? 0 })
                                                }} />
                                                <UserAvatar idUser={flight.idUserPilot} width={20} />
                                            </SpaceBetween>
                                        </FormField>
                                        {flight.idFlightType !== undefined && (flight.idFlightType === 1135 || flight.idFlightType === 1133) && (
                                            <FormField label={"Instructor"}>
                                                <SpaceBetween direction='horizontal' size='xs'>
                                                    <SelectUser value={flight.idUserInstructor} filter='GLIDER' onConfirm={(usr) => {
                                                        setFlight({ ...flight, idUserInstructor: usr?.idUser ?? 0 })
                                                    }} />
                                                    <UserAvatar idUser={flight.idUserInstructor} width={20} />
                                                </SpaceBetween>
                                            </FormField>
                                        )}

                                        {altitudes && altitudes.length > 0 && (
                                            <>
                                                <FormField label="Altura remolque">
                                                    <Select
                                                        placeholder="Seleccione"
                                                        expandToViewport={true}
                                                        selectedOption={altitude ?? null}
                                                        onChange={({ detail }) => {
                                                            if (Number(detail.selectedOption.value) === 0) {
                                                                setFlight({ ...flight!, altitude: Number(detail.selectedOption.value), idUserTow: 0, idEquipmentTow: 0 });
                                                            } else {
                                                                setFlight({ ...flight!, altitude: Number(detail.selectedOption.value) });
                                                            }
                                                            //console.log(detail.selectedOption)
                                                            setAltitude(detail.selectedOption as ItemAltitudes);

                                                        }}
                                                        options={[{ altitude: -1, value: "-1", label: "Selecione" },
                                                        ...altitudes, { altitude: 0, value: "0", label: "Autodespegue" }
                                                        ]}
                                                    />
                                                </FormField>
                                                {flight.altitude > 0 && (
                                                    <SpaceBetween direction='vertical' size='xs'>
                                                        <FormField label={"Remolcador"}
                                                            constraintText={
                                                                distinctEquipmentsTow.map((id: number) => {
                                                                    const registration = getEquipment(id, data)?.registration.replace("CC-", "");
                                                                    if (!registration) return null;
                                                                    return (<Link
                                                                        key={id}
                                                                        variant="primary"
                                                                        onClick={() => {
                                                                            setFlight({ ...flight, idEquipmentTow: id })
                                                                        }}
                                                                    >{registration} </Link>);
                                                                })
                                                            }
                                                        >
                                                            <SelectEquipment
                                                                key={`R${flight.idEquipmentTow}`}
                                                                idCategory={911557}
                                                                value={flight.idEquipmentTow} onConfirm={(eq) => {
                                                                    setFlight({ ...flight, idEquipmentTow: eq?.idEquipment ?? 0 })

                                                                }} />
                                                        </FormField>
                                                        <FormField label={"Piloto remolcador"}
                                                            constraintText={
                                                                distinctTowings.map((id: number) => {
                                                                    const registration = getUser(id, data)?.displayName;
                                                                    if (!registration) return null;
                                                                    return (<Link
                                                                        key={id}
                                                                        variant="primary"
                                                                        onClick={() => {
                                                                            setFlight({ ...flight, idUserTow: id })
                                                                        }}
                                                                    >{registration} </Link>);
                                                                })
                                                            }
                                                        >
                                                            <SpaceBetween direction='horizontal' size='xs'>
                                                                <SelectUser
                                                                    value={flight?.idUserTow}
                                                                    filter={`TOWING`}
                                                                    onConfirm={(detail) => {
                                                                        if (!flight) return

                                                                        setFlight((prev) => ({
                                                                            ...prev!,
                                                                            idUserTow: Number(detail?.idUser),
                                                                            userTow: detail?.displayName || "",
                                                                        }))
                                                                    }} />
                                                                <UserAvatar idUser={flight.idUserTow} width={20} />
                                                            </SpaceBetween>
                                                        </FormField>
                                                    </SpaceBetween>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}

                            </SpaceBetween>

                        </Modal>
                    )}
                    {filteredFlights.length === 0 && (
                        <Container variant="default">
                            <Box textAlign='center'>
                                <SpaceBetween direction='vertical' size='xs'>
                                    <strong>Sin vuelos registrados</strong>
                                    {shift?.idUserDirector === idUser && (
                                        <Button variant="primary" onClick={() => initFlight()}>
                                            Agregar vuelo
                                        </Button>
                                    )}
                                </SpaceBetween>
                            </Box>
                        </Container>
                    )}
                    {filteredFlights !== undefined && (
                        filteredFlights.map((f: ItemShiftFlight) => (
                            <ItemCard
                                actions={
                                    <Link onClick={() => setFlightEdit(f)} variant="secondary"><Icon path={mdiClockEditOutline} size={1} color='black' /></Link>
                                }

                                description={
                                    <SpaceBetween direction='horizontal' size='xs'>

                                        {f.altitude > 0 ? `${f.registrationTow}: ${f.altitude}m` : "S/remolque"}
                                        {f.userTow}
                                    </SpaceBetween>
                                }
                                footer={
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", }}>
                                        <div>{flightStatus(f)}</div>
                                        <div>
                                            <Link onClick={() => {
                                                const updatedFlight = { ...f };
                                                delete updatedFlight.arrivalDate;
                                                delete updatedFlight.departureDate;
                                                delete updatedFlight.arrivalDateTow;
                                                delete updatedFlight.obs;
                                                updatedFlight.isClosed = 0;
                                                updatedFlight.isDelete = 0;
                                                updatedFlight.idFlight = 0;
                                                setFlightCopy(updatedFlight);
                                            }}><Icon path={mdiContentCopy} size={1} color='black' /></Link>
                                            {f.isDelete === 0 ? <Link onClick={() => {
                                                setFlightDelete(f);
                                            }}><Icon path={mdiDelete} size={1} color='black' /></Link> :

                                                <Link onClick={() => {
                                                    setFlightRestore(f);
                                                }}><Icon path={mdiBackupRestore} size={1} color='black' /></Link>

                                            }</div>
                                    </div>
                                }
                                header={<>
                                    {f.registration} <BadgeCustom color={f.flightTypeBadge} size='small'>{f.flightType}</BadgeCustom>
                                </>}
                            >
                                {f.userPilot} {f.idUserInstructor > 0 ? <> | <Icon path={mdiHumanMaleBoard} size={0.75} />{f.userInstructor}</> : ""}
                            </ItemCard>
                        )))}

                    {flightEdit !== undefined && (
                        <Modal size="medium" header={"Horarios"} visible={flightEdit !== undefined}
                            onDismiss={() => setFlightEdit(undefined)}
                            footer={
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >
                                    <Button variant="link" onClick={() => setFlightEdit(undefined)}>Cancelar</Button>
                                    <Button variant="primary" onClick={() => handleUpdateFlight("edit")}>Actualizar</Button>
                                </div>
                            }
                        >
                            <FormField label="Hora despegue">
                                <TPModal
                                    key={"departureDate"}
                                    time={flightEdit.departureDate}
                                    onConfirm={(time) => {
                                        setFlightEdit((prev) => ({
                                            ...prev!,
                                            departureDate: time,
                                        }))
                                    }} />
                            </FormField>
                            {flightEdit.altitude > 0 && (
                                <FormField label="Hora aterrizaje remoque">
                                    <TPModal
                                        disabled={flightEdit.departureDate === ""}

                                        key={"arrivalDateTow"}
                                        time={flightEdit.arrivalDateTow} onConfirm={(time) => {
                                            //console.log("Landing set")
                                            setFlightEdit((prev) => ({
                                                ...prev!,
                                                arrivalDateTow: time,
                                            }))
                                        }} />
                                </FormField>
                            )}

                            <FormField label="Hora aterrizaje aeronave">
                                <TPModal
                                    disabled={flightEdit.departureDate === ""}
                                    key={"arrivalDate"}
                                    time={flightEdit.arrivalDate} onConfirm={(time) => {
                                        setFlightEdit((prev) => ({
                                            ...prev!,
                                            arrivalDate: time,
                                        }))
                                    }} />
                            </FormField>

                        </Modal>
                    )}
                    {flightDelete && (
                        <ConfirmDelete header='Eliminar vuelo' show={flightDelete !== undefined} confirmWord={'eliminar'} action={'Eliminar vuelo'} warning={'Un vuelo eliminado solo se muestra en el filtro eliminados. Desde el listado de eliminados puede restaurar el vuelo'} onDismiss={() => setFlightDelete(undefined)}
                            onConfirm={() => {
                                handleFlightDelete(1);
                            }}
                            subtitle={
                                <span>
                                    Eliminar vuelo del <strong>{flightDelete.registration}</strong>
                                    {" de "}
                                    <strong>{flightDelete.userPilot}</strong>
                                    {" del tipo "}
                                    <strong>{flightDelete.flightType}</strong>
                                </span>
                            }
                        />
                    )}

                    <ConfirmDelete header='Restaurar vuelo' show={flightRestore !== undefined} confirmWord={'restaurar'} action={'Restaurar vuelo'} warning={'Un vuelo restaurado vuelve al listado de activos'} onDismiss={() => setFlightRestore(undefined)}
                        onConfirm={() => {
                            handleFlightDelete(0);
                        }}
                    />
                    {flightCopy && (
                        <Modal header={"Copiar vuelo"} visible={!!flightCopy} onDismiss={() => setFlightCopy(undefined)}
                            footer={
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", }}>
                                    <Button variant="link" onClick={() => setFlightCopy(undefined)}>Cancelar</Button>
                                    <Button variant="primary" onClick={() => {

                                        handleUpdateFlight("COPY")

                                    }}>Copiar</Button>
                                </div>
                            }
                            size="small"

                        >
                            <SpaceBetween direction='horizontal' size='xs'>
                                Copiar el vuelo del <strong>{flightCopy.registration}</strong> de <strong>{flightCopy.userPilot}, del tipo {flightCopy.flightType}</strong>
                                <Alert type='info' header={"Información"} >
                                    Al copiar un vuelo, se copian todos los datos del vuelo seleccionado, exeptuando las horas de despegue, aterrizaje remolcador y planeador
                                </Alert>
                            </SpaceBetween>
                        </Modal>
                    )}


                </SpaceBetween>
            }
        />
    )
};
